import React from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Link } from "react-router-dom";
import "../../styles/Documents.css";
import PageInfoTooltip from "./PageInfoTooltip";

// showBreadcrumb: pass false on a page's main/list view, where the Sidebar
// already makes the current location clear - true (the default) only when
// showing deeper content (an opened document/PDF, a group, a folder, etc.),
// per the "breadcrumb only for deeper content" convention used app-wide.
// showHeader: pass false once a specific document/PDF is open, since the
// viewer (PdfViewer) shows its own file-type/name/status/date header right
// below - keeps the breadcrumb (still governed by showBreadcrumb) without
// this page-level icon/title/description/action row duplicating it.
// headerSpacingClass: vertical padding of the header row (default py-2; the
// Mail Room list pages pass "py-3" to match the /documents header).
const DocumentsPageHeader = ({ breadcrumbs, icon: Icon, title, description, action, showBreadcrumb = true, showHeader = true, headerSpacingClass = "py-2" }) => (
  <>
    {showBreadcrumb && (
      <div className="documents-breadcrumb flex items-center gap-1 text-sm text-gray-500 shrink-0">
        {breadcrumbs.map((breadcrumb, index) => (
          <React.Fragment key={`${breadcrumb.label}-${index}`}>
            {index > 0 && <ChevronRightIcon sx={{ fontSize: 16 }} />}
            {breadcrumb.to ? (
              <Link to={breadcrumb.to} className="hover:text-nbl-primary hover:underline">
                {breadcrumb.label}
              </Link>
            ) : breadcrumb.onClick ? (
              <span className="text-nbl-primary hover:underline cursor-pointer" onClick={breadcrumb.onClick}>
                {breadcrumb.label}
              </span>
            ) : (
              <span className={index === breadcrumbs.length - 1 ? "text-gray-900 font-medium" : ""}>
                {breadcrumb.label}
              </span>
            )}
          </React.Fragment>
        ))}
      </div>
    )}
    {showHeader && (
      <div className={`documents-page-header flex items-center justify-between gap-3 ${headerSpacingClass} shrink-0`}>
        <div className="flex items-center gap-3 min-w-0">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-nbl-primary text-white">
            {Icon && <Icon sx={{ fontSize: 18 }} />}
          </span>
          <span className="min-w-0">
            <span className="flex items-center gap-1.5 min-w-0">
              <h1 className="text-lg font-semibold text-gray-900 leading-tight truncate min-w-0">{title}</h1>
              <PageInfoTooltip title={title} description={description} />
            </span>
            <p className="text-xs text-gray-500 leading-tight truncate">{description}</p>
          </span>
        </div>
        {action}
      </div>
    )}
  </>
);

export default DocumentsPageHeader;
